import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { getDate } from "../../../../helpers/dateHelper";
import { Coupon, CouponTypes } from "../../../../types/coupons";
import { AppButton } from "../../ctaButton/button";
import { useDataProvider } from "react-admin";

import "./style.css";

interface Props {
  coupon: Coupon;
  closeModal: () => void;
  showModal: boolean;
  couponStatusType: "server" | "client";
}

export const CouponViewModal = ({
  coupon,
  closeModal,
  showModal,
  couponStatusType,
}: Props) => {
  const [count, setCount] = useState(0);
  const dataProvider = useDataProvider();

  useEffect(() => {
    if (coupon.type === "DREAMHOME" && coupon.limit) {
      getCount();
    }
  })

  const getCount = async (): Promise<void> => {
    const used = await dataProvider.getCouponCountUsed("/coupons/count", {
      _id: coupon._id,
    }) as any;
    setCount(used.data ? used.data : 0);
  }

  return (
    <div>
      {coupon && (
        <ReactModal
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById("root")}
          onClose={closeModal}
          isOpen={showModal}
          contentLabel="Inline Styles Modal Example"
          className="globalModalWrapper"
          style={{
            overlay: {
              backgroundColor: "rgba(9, 16, 29, 0.6)",
              zIndex: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="couponModalContentWrapper">
            <div className="modalHeader">
              <span>View Coupon details</span>
            </div>
            <div className="modalBody modalBody_view">
              <div className="side side_left">
              {coupon.batchTitle &&
                <CouponDataBlock
                  title="Batch Coupon #"
                  allowWhitespaces={true}
                  content={coupon.batchTitle}
                />
              }
                <CouponDataBlock
                  title="Coupon #"
                  allowWhitespaces={true}
                  content={coupon.title}
                />
                <CouponDataBlock
                  title="Status"
                  content={coupon.isActive ? "Active" : "Inactive"}
                />
                <CouponDataBlock title="Type" content={coupon.type} />
                {coupon.type === CouponTypes.Prize ? (
                  <>
                    {/* <CouponDataBlock
                      title="Category"
                      content={coupon.prize.prizeCategory.title}
                    />
                    <CouponDataBlock
                      title="Sub Category"
                      content={coupon.prize.subCategory.title}
                    /> */}
                    <CouponDataBlock
                      title="Prize"
                      content={coupon.prize.title}
                    />
                  </>
                ) : null}
                {coupon.type === CouponTypes.FixedOdds ? (
                  <CouponDataBlock
                    title="Prize"
                    content={coupon.fixedOdds.title}
                  />
                ) : null}
                {coupon.type === CouponTypes.DreamHome ? (
                  <CouponDataBlock
                    title="Title"
                    content={coupon.raffle?.title || ""}
                  />
                ) : null}
                {coupon.type === CouponTypes.DreamHome && coupon.limit && (
                  <div className="modalBody_view">
                    <CouponDataBlock
                      title="Usage Limits"
                      content={`${count.toString()} / ${coupon.limit.toString()}`}
                    />
                  </div>
                )}
              </div>
              <div className="side side_right">
                <CouponDataBlock
                  type="inline"
                  title="Date of use"
                  content={
                    coupon.dateOfUse
                      ? getDate(new Date(coupon.dateOfUse))
                      : "---"
                  }
                />
                <CouponDataBlock
                  title="Basket amount"
                  content={
                    coupon.basketAmount || coupon.basketAmount === 0
                      ? "" + coupon.basketAmount / 100
                      : "---"
                  }
                />
                <CouponDataBlock
                  title="Fixed odds amount"
                  content={
                    coupon.fixedOddsTickets
                      ? "" + coupon.fixedOddsTickets
                      : "---"
                  }
                />
                {coupon.discountDurationMonths && (
                  <CouponDataBlock
                    title="Coupon discount months"
                    content={
                      coupon.discountDurationMonths
                        ? "" + coupon.discountDurationMonths
                        : "---"
                    }
                  />
                )}
                <CouponDataBlock
                  title={
                    coupon.type === CouponTypes.Basket ||
                    coupon.type === CouponTypes.SingleBasketPerUser ||
                    coupon.type === CouponTypes.SubscriptionBasket ||
                    coupon.type ===
                      CouponTypes.SingleSubscriptionBasketPerUser ||
                    coupon.type === CouponTypes.SingleSubscriptionPerUser ||
                    coupon.type === CouponTypes.SingleSubscription ||
                    coupon.type === CouponTypes.SingleOrder ||
                    coupon.type === CouponTypes.SingleOrderPerUser
                      ? "Discount"
                      : coupon.type === CouponTypes.Credit
                      ? "Credits"
                      : "Tickets"
                  }
                  content={
                    `${coupon.value} ${
                      coupon.type === CouponTypes.Basket ||
                      coupon.type === CouponTypes.SingleBasketPerUser ||
                      coupon.type === CouponTypes.Credit ||
                      coupon.type === CouponTypes.SubscriptionBasket ||
                      coupon.type ===
                        CouponTypes.SingleSubscriptionBasketPerUser ||
                      coupon.type === CouponTypes.SingleSubscriptionPerUser ||
                      coupon.type === CouponTypes.SingleSubscription ||
                      coupon.type === CouponTypes.SingleOrder ||
                      coupon.type === CouponTypes.SingleOrderPerUser
                        ? "%"
                        : ""
                    }` || "---"
                  }
                />
              </div>
            </div>
            <div className="descriptionRow">
              <CouponDataBlock
                title="Description"
                content={coupon.description}
              />
            </div>
            <div className="modalFooter">
              <AppButton onClick={closeModal} size="long" text="Ok" />
            </div>
          </div>
        </ReactModal>
      )}
    </div>
  );
};

interface DataField {
  type?: "inline" | "default";
  title: string;
  content: string;
  allowWhitespaces?: boolean;
}
const CouponDataBlock = ({
  type,
  title,
  content,
  allowWhitespaces,
}: DataField) => (
  <div className={type === "inline" ? "row inline" : "row"}>
    <p className="fieldHeader">{title}</p>
    <p
      className={allowWhitespaces ? "fieldData allowWhitespaces" : "fieldData"}
    >
      <span>{content}</span>
    </p>
  </div>
);
